<template>
  <div>
      <vue-dropzone ref="myVueDropzone" id="customdropzone" :options="dropzoneOptions"
      @vdropzone-file-added="fileAdded" @vdropzone-complete="afterComplete" @vdropzone-removed-file="removeFile"
      :useCustomSlot=true @vdropzone-queue-complete="afterAllComplete"
      :duplicateCheck=true>
        <div class="dropzone-custom-content">
          <div class="subtitle">
            <span class="upload-icon"><img src="@/assets/images/arrow-right-green.svg"/></span>
            <span>{{dropzoneText}}</span>
          </div>
        </div>
      </vue-dropzone>
  </div>
</template>

<script>

import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import router from '@/router';

export default {
  name: 'VueDropzone',
  props: {
    dropzoneText: {
      default: null,
    },
  },
  components: {
    vueDropzone: vue2Dropzone,
  },
  computed: {
  },
  data() {
    return {
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        acceptedFiles: '.jpeg,.jpg,.png,.pdf',
        maxFilesize: 10, // MB
        createImageThumbnails: true,
        thumbnailMethod: 'contain',
        addRemoveLinks: true,
        parallelUploads: 5,
        timeout: 180000,
      },
      files: [],
    };
  },
  methods: {
    afterComplete(file) {
      console.log(file);
    },
    removeFile(file, error, xhr) {
      this.files = this.$refs.myVueDropzone.getAcceptedFiles();
      this.$emit('file-uploaded', { files: this.files });
    },
    fileAdded(file) {
      // remove icon show
      this.$emit('file-uploading');
    },
    afterAllComplete() {
      this.files = this.$refs.myVueDropzone.getAcceptedFiles();
      this.$emit('file-uploaded', { files: this.files });
    },
  },
};
</script>

<style lang="scss" scoped>
#customdropzone {
    border-radius: 4px;
    @apply ut-border-2 ut-border-green-400 ut-border-dashed;
    font-family: 'Arial', sans-serif;
    letter-spacing: 0.2px;
    color: #777;
    transition: background-color .2s linear;
  }
  .dropzone-custom-content {
    display: inline;
    transform: translate(-50%, -50%);
    text-align: center;
    max-width: 300px;
  }
  .subtitle {
    color: #314b5f;
    font-size:14px;
    @apply ut-font-sans;
    .upload-icon {
      @apply ut-mr-4;
    }
  }

  #preview_files_section {
    list-style: none;
    opacity: 0.5;
    padding: 0;
    @apply ut-mt-8;
  }


</style>
